import { render } from "./CustomTermEditorWithAI.vue?vue&type=template&id=034c97b6&scoped=true"
import script from "./CustomTermEditorWithAI.vue?vue&type=script&lang=js"
export * from "./CustomTermEditorWithAI.vue?vue&type=script&lang=js"

import "./CustomTermEditorWithAI.vue?vue&type=style&index=0&id=034c97b6&scoped=true&lang=css"

import exportComponent from "D:\\Work\\Contractly\\Contractly.Site\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-034c97b6"]])

export default __exports__